import { NavItem } from '@hakimo-ui/hakimo/ui-navigation';
import { ApplianceIcon } from '@hakimo-ui/hakimo/ui-elements';
import {
  ClipboardDocumentListIcon,
  RectangleGroupIcon,
} from '@heroicons/react/24/outline';

export const navItems: NavItem[] = [
  // {
  //   id: 'tenants',
  //   name: 'Tenants',
  //   href: '/tenants',
  //   icon: RectangleGroupIcon,
  //   requiredPermissions: ['admin_ui:access'],
  // },
  {
    id: 'tenants-admin',
    name: 'Tenants',
    href: '/tenants-admin',
    icon: RectangleGroupIcon,
    requiredPermissions: ['admin_ui:access'],
  },
  {
    id: 'appliances',
    name: 'Appliances',
    href: '/appliances',
    icon: ApplianceIcon,
    requiredPermissions: ['appliances:view'],
  },
  {
    id: 'admin-audit-log',
    name: 'Admin Audit Log',
    href: '/admin-audit-log',
    icon: ClipboardDocumentListIcon,
    requiredPermissions: ['admin-audit-log:view'],
  },
  // {
  //   id: 'user-management',
  //   name: 'User Management',
  //   href: '/user-management',
  //   icon: UserGroupIcon,
  //   requiredPermissions: ['admin_ui:access'],
  // },
];
